import React from 'react'
import News from './News';

const App = () => {
  return (
    <>
    <News/>
    </>  
    )
}


export default App;